export default __webpack_public_path__ + "static/roadside-901b178d9d5bee053dd929e990251d42.svg";